/** @format */

const template = `
<div class="modal-header">
  <h2 class="modal-title" id="modal-title">
    <span translate="STUDIES.PREREQUISITES_EDITOR.EDIT_PREREQUISITE_GROUP_MODAL.TITLE"></span>
  </h2>
</div>
<div class="modal-body" id="modal-body">
  <ng-form name="addPrerequisiteModalWindowForm">
    <div ng-repeat="prerequisite in $ctrl.prerequisiteGroup.prerequisites" class="single-prerequisite-in-editor">
      <div class="row">
        <div class="col-10">
          <sis-course-unit-box
            ng-if="prerequisite.type === 'CourseUnit'  && !!prerequisite.courseUnitGroupId"
            [course-unit-group-id]="prerequisite.courseUnitGroupId"></sis-course-unit-box>
          <sis-module-box
            ng-if="prerequisite.type === 'Module' && !!prerequisite.moduleGroupId"
            [module-group-id]="prerequisite.moduleGroupId"></sis-module-box>
          <prerequisite-selector
            ng-if="!prerequisite.courseUnitGroupId && !prerequisite.moduleGroupId"
            prerequisite-index="$index"
            type="prerequisite.type"
            on-select="$ctrl.doSelect">
          </prerequisite-selector>
        </div>
        <div class="col-2">
          <button
            class="btn btn-primary btn-naked btn-lg form-control simulate-label"
            ng-class="{'not-after-input-field': prerequisite.courseUnitGroupId || prerequisite.moduleGroupId}"
            ng-click="$ctrl.removePrerequisite($index)">
            <sis-icon icon="delete"></sis-icon>
          </button>
        </div>
      </div>
    </div>
  </ng-form>
  <div class="row add-new-buttons">
    <div class="col-6">
      <button type="button" class="link-button" ng-click="$ctrl.addNewCourseUnitPrerequisite()">
        <sis-icon icon="ring-plus"></sis-icon>{{'STUDIES.PREREQUISITES_EDITOR.EDIT_PREREQUISITE_GROUP_MODAL.ADD_COURSE_UNIT' | translate}}
      </button>
    </div>
    <div class="col-6">
      <button type="button" class="link-button" ng-click="$ctrl.addNewModulePrerequisite()">
        <sis-icon icon="ring-plus"></sis-icon>{{'STUDIES.PREREQUISITES_EDITOR.EDIT_PREREQUISITE_GROUP_MODAL.ADD_MODULE' | translate}}
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <span class="guidance" translate>STUDIES.PREREQUISITES_EDITOR.EDIT_PREREQUISITE_GROUP_MODAL.HINT</span>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary btn-hollow btn-lg" type="button" ng-click="$ctrl.cancel()" translate> CANCEL </button>
  <button
    class="btn btn-primary btn-lg"
    type="button"
    ng-click="$ctrl.ok()"
    ng-disabled="addPrerequisiteGroupModalWindowForm.$invalid || $ctrl.prerequisiteGroup.length==0"
    translate>
    SIS_COMPONENTS.BUTTON.DONE
  </button>
</div>
`;
export default template;
